import { render, staticRenderFns } from "./full-width-layout.vue?vue&type=template&id=a9628afa&scoped=true&"
import script from "./full-width-layout.vue?vue&type=script&lang=ts&"
export * from "./full-width-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9628afa",
  null
  
)

export default component.exports